const backTop = (gsap) => {
    if (document.querySelector(".back-to-top")) {
        const backBox = document.querySelector(".back-to-top");
        const backButton = document.querySelector(".back-to-top").firstElementChild;

        if (backButton) {
            gsap.set(backBox, {
                alpha: 0,
                y: 150,
            });

            function scrollFunction() {
                if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                    gsap.to(backBox, {
                        alpha: 1,
                        y: 0,
                        duration: 0.5,
                        ease: "back.out(1)",
                    });
                } else {
                    gsap.to(backBox, {
                        alpha: 0,
                        y: 150,
                        duration: 1,
                        ease: "back.out(1)",
                    });
                }
            }

            window.onscroll = function () {
                scrollFunction();
            };

            backButton.addEventListener("click", (event) => {
                event.preventDefault();
                gsap.to(window, {
                    duration: 1.5,
                    ease: "back.out(1)",
                    scrollTo: { y: 0 },
                });
                document.querySelector("main").focus();
            });
        }
    }
};

export { backTop };
